import { AvatarColorType, AvatarSizeType } from '../types';

export const AVATAR_COLORS_MAP: Record<AvatarColorType, string> = {
  default: 'avatar--color',
  primary: 'avatar--color-primary',
  green: 'avatar--color-green',
  orange: 'avatar--color-orange',
  red: 'avatar--color-red',
  purple: 'avatar--color-purple',
  turquoise: 'avatar--color-turquoise',
  yellow: 'avatar--color-yellow',
};

export const AVATAR_SIZES_MAP: Record<AvatarSizeType, string> = {
  '20': 'avatar--size-20',
  '24': 'avatar--size-24',
  '30': 'avatar--size-30',
  '50': 'avatar--size-50',
  '60': 'avatar--size-60',
  '80': 'avatar--size-80',
};
